import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  palette: {
    common: { black: '#000', white: '#fff' },
    primary: {
      light: '#3f5c94',
      main: '#003366',
      dark: '#000c3b',
      contrastText: '#fff'
    },
    secondary: {
      light: '#6de6b1',
      main: '#34b381',
      dark: '#008254'
    }
  }
})
export default theme
